export const PROJ_PFX = 'lsnweb_'
export const LANG = 'LANG'
export const AVAILABLE_LANGS = 'AVAILABLE_LANGS'

// Config key names
export const CONF_DC_APP_NAME = 'DC_APP_NAME'
export const CONF_DC_APP_AUTHLINK = 'DC_APP_AUTHLINK'
export const CONF_DC_APP_LINK = 'DC_APP_LINK'
export const CONF_BASE_URL = 'BASE_URL'
export const CONF_ADMINAPP_URL = 'ADMINAPP_URL'
export const CONF_MAX_BOT_NAME = 'MAX_BOT_NAME'
export const CONF_TG_BOT_NAME = 'TG_BOT_NAME'
export const CONF_VB_BOT_NAME = 'VB_BOT_NAME'
export const CONF_TAMTAM_BOT_NAME = 'TAMTAM_BOT_NAME'
export const CONF_DISCORD_BOT_NAME = 'DISCORD_BOT_NAME'
export const CONF_VK_COMMUNITY_LINK = 'VK_COMMUNITY_LINK'
export const CONF_CLIENT_SITE_LINK = 'CLIENT_SITE_LINK'
export const CONF_CLEINT_LOGO_PREFIX = 'CLEINT_LOGO_PREFIX'
export const HIDE_SIDEBAR_LINKS = 'HIDE_SIDEBAR_LINKS'
export const CONF_MESSENGER_MAX = 'MESSENGER_MAX'
export const CONF_MESSENGER_VK = 'MESSENGER_VK'
export const CONF_MESSENGER_TG = 'MESSENGER_TG'
export const CONF_MESSENGER_VB = 'MESSENGER_VB'
export const CONF_MESSENGER_TAMTAM = 'MESSENGER_TAMTAM'
export const CONF_MESSENGER_DISCORD = 'MESSENGER_DISCORD'
export const CUSTOM_LOGIN_PAGE = 'CUSTOM_LOGIN_PAGE'
export const WIDGET_REQUIRED_MESSENGER = 'WIDGET_REQUIRED_MESSENGER'
export const PAGE_TITLE = 'PAGE_TITLE'
export const PAGE_DESCRIPTION = 'PAGE_DESCRIPTION'

export const CONF_USE_SNS = 'USE_SNS'
export const CONF_TECHNOLOGY_LINK = 'TECHNOLOGY_LINK'

export const HIDE_MESSAGE_INPUT = 'HIDE_MESSAGE_INPUT'

export const CONF_LOGIN_INPUT_LABEL = 'LOGIN_INPUT_LABEL'
export const CONF_GET_ACCOUNT_TEXT = 'GET_ACCOUNT_TEXT'
export const CONF_FORGET_PASSWORD_TEXT = 'FORGET_PASSWORD_TEXT'
export const CONF_FORGET_PASSWORD_REDIRECT = 'FORGET_PASSWORD_REDIRECT'

export const CONF_THIRD_PARTY_SSO = 'THIRD_PARTY_SSO'
export const CONF_URL_SSO = 'URL_SSO'

// ERROR
export const E_NOT_FOUND = 'E_NOT_FOUND'
export const E_STATUS = 'E_STATUS'

// Config required props
export const CONF_REQ_PROPS = [
  CONF_BASE_URL,
  CONF_ADMINAPP_URL,
  CONF_TG_BOT_NAME,
  CONF_VB_BOT_NAME,
  CONF_TAMTAM_BOT_NAME,
  CONF_VK_COMMUNITY_LINK,
  CONF_CLIENT_SITE_LINK,
  CONF_CLEINT_LOGO_PREFIX
]

// User Roles
export const MSGR_MAX = 'mx';
export const MSGR_VK = 'vk';
export const MSGR_TG = 'tg';
export const MSGR_VB = 'vb';
export const MSGR_TAMTAM = 'tamtam';
export const MSGR_TT = 'tt';
export const MSGR_DISCORD = 'dc';
export const MSGR_LDP = 'ldp'

// Resp Statuses
export const RESP_STATUS_BLANK = 'BLANK'
export const RESP_STATUS_FILLED = 'FILLED'
export const RESP_STATUS_EXPIRED = 'EXPIRED'

// Polls Statuses
export const POLL_STATUS_OPEN = 'OPEN'
export const POLL_STATUS_FINISHED = 'FINISHED'

// MESSAGES
export const MESSAGE_TYPE_STAFFUSER = 'STAFFUSER'
export const MESSAGE_TYPE_LSNUSER = 'LSNUSER'
export const MESSAGE_TYPE_MAILING = 'MAILING'
export const MESSAGE_TYPE_POLL = 'POLL'
export const MESSAGE_TYPE_NOTIFY = 'NOTIFY'
export const MESSAGE_TYPE_MANAGER = 'MANAGER'
export const MESSAGE_MSGR_STATUS_OK = 'OK'
export const MESSAGE_MSGR_STATUS_ERR = 'ERR'
export const MESSAGE_VOTE_TYPE_YESNO = 'YESNO'
export const MESSAGE_VOTE_TYPE_STARS5 = 'STARS5'
export const MESSAGE_VOTE_TYPE_LIKE = 'LIKE'
export const MESSAGE_VOTE_RESULT_YES = 'yes'
export const MESSAGE_VOTE_RESULT_NO = 'no'
export const MESSAGE_VOTE_RESULT_1 = '1'
export const MESSAGE_VOTE_RESULT_2 = '2'
export const MESSAGE_VOTE_RESULT_3 = '3'
export const MESSAGE_VOTE_RESULT_4 = '4'
export const MESSAGE_VOTE_RESULT_5 = '5'
export const MESSAGE_VOTE_RESULT_LIKE = 'like'

// API
export const API = {
  cproc: {
    entery: '/cproc',
    lsnInfo: 'cproc/lsn_info',
    getCode: 'cproc/get_code',
    dropAuth: 'cproc/drop_auth',
    respKey: 'cproc/resp_key',
    respGet: 'cproc/resp_get',
    respAns: 'cproc/resp_ans',
    respFind: 'cproc/resp_find',
    postMessage: 'chat.lsnuser/post_message',
    listMessages: 'chat.lsnuser/list_messages',
    getMessages: 'chat.lsnuser/get_messages',
    logExternal: 'cproc/log_external',
    newsfeedInfo: 'cproc/newsfeed_info',
    newsfeedStatus: 'cproc/newsfeed_status',
    schedGet: 'cproc/user/calend',
    profileUpdate: 'cproc/user/profile/update'
  },
  wiki: {
    nodeGet: 'wiki/node_get',
    nodeList: 'wiki/node_list',
    pageList: 'wiki/page_list',
    pageGet: 'wiki/page_get'
  }
}

// SCHEDULE_PAGE
export const SCHEDULE_GROUP_NAME = 'Учебная группа';
export const PRIVACY_POLICY = 'PRIVACY_POLICY'